import React, { useState, useEffect } from 'react';
import { imageService } from '../../service';
import ImageList from '@material-ui/core/ImageList';
import ImageListItem from '@material-ui/core/ImageListItem';
import ImageListItemBar from '@material-ui/core/ImageListItemBar';
import IconButton from '@material-ui/core/IconButton';
import InfoIcon from '@material-ui/icons/Info';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import makeStyles from '@material-ui/core/styles/makeStyles';


const useStyles = makeStyles(theme => ({
  checked: {
    color: theme.palette.success.main
  }
}));

const PrintPhotoBrowser = ({ imagesToImport, setImagesToImport }) => {
  const [images, setImages] = useState([]);

  const classes = useStyles();

  const fetchImages = async () => {
    const images = await imageService.getAll(23, 53, 0, 'print');
    setImages(images.images);
  };

  useEffect(() => {
    setImagesToImport([]);
    fetchImages();
  }, []);

  const handleImageClick = (event) => {
    const id = event.currentTarget.id;
    const selectedImage = images.find(image => image.file_name == id);
    const isSelected = imagesToImport.find(image => image.file_name === id);
    isSelected
      ? setImagesToImport(imagesToImport.filter(image => image.file_name !== id))
      : setImagesToImport([].concat(...imagesToImport, selectedImage));
  };

  return (
    <>
      <ImageList>
        {images.map(image =>
          <ImageListItem
            id={image.file_name}
            key={image.file_name}
            onClick={handleImageClick}>
            <img
              src={`https://yklmtst.blob.core.windows.net/ykl-mt-files/${image.file_name}`}/>
            <ImageListItemBar
              title={image.file_name}
              subtitle={<span></span>}
              actionIcon={
                <IconButton aria-label={'info about'}>
                  {imagesToImport.find(img => img.file_name === image.file_name)
                    ? <CheckCircleIcon className={classes.checked} />
                    : <InfoIcon />}
                </IconButton>
              }
            />
          </ImageListItem>
        )}
      </ImageList>
    </>
  );
};


export default PrintPhotoBrowser;